import { CopyButton } from "~/components/assistant/CopyButton";

// Lets the user copy the full list of members lacking access — e.g. to send to
// an admin — since the warnings only name the first few.
export const CopyAllEmailsButton = ({ emails }: { emails: string[] }) => (
  <CopyButton
    text={emails.join(", ")}
    variant="ghost"
    size="sm"
    className="-my-0.5 shrink-0 p-0.5"
    tooltipText="Copy all emails"
  />
);
